import { render, staticRenderFns } from "./NewsRelatedList.vue?vue&type=template&id=8d4691c2"
import script from "./NewsRelatedList.vue?vue&type=script&lang=js"
export * from "./NewsRelatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports